import axios from 'axios';
import { AuthenticationService } from '../Services/AuthenticationService';

export class ApiService {

    static async getProjectData(projectName: string) {
        let url = await AuthenticationService.getBaseUrl() + '/api/enduser/ProjectInformation/' + projectName;
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getContactData() {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/customer/Contact';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getAccountsData() {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/customer/Account/Metadata';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getFiles(dospId: string) {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/Files/' + dospId + '/File';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async downloadFile(dospId: string, fileId: string) {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/Files/' + dospId + '/File/' + fileId;
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                Authorization: authHeader,
            },
        });
    }

    static async uploadFile(fileId: string, fileContent: string, fileName: string, mimeType: string, documentTypeId?: string) {

        var data: any = {
            "fileContent": fileContent,
            "fileName": fileName,
            "mimeType": mimeType
        }

        if (documentTypeId) {
            data["documentTypeId"] = documentTypeId;
        }

        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/Files/' + fileId + '/FileUpload';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    // META DATA
    static async getAccountTypes() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/AccountType';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }
    static async getAccountTypesOnly() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/AccountType/Type';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }
    static async getAccountSubTypesOnly() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/AccountType/SubType';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getMemberTypes() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/MemberType';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getRoleTypes() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/Type/memberroles';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getThemes() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/Theme';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getDisciplineCodes() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/DisciplineCode';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async getContactGroups() {
        const url = await AuthenticationService.getBaseUrl() + '/api/metadata/ContactGroup';
        const token = await getToken();

        const authHeader = ` ${token}`;
        return axios.get(url, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    // UPSERT
    static async upsertContact(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/ProjectMemberRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postThemes(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/ThemeRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postDisciplineCodes(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/DisciplineCodeRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postFocuslines(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/FocuslineRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postProject(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/RequestChangeOnGeneralInfo';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postStakeholder(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/ProjectMemberRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }

    static async postPartner(data: any) {
        const url = await AuthenticationService.getBaseUrl() + '/api/enduser/StakeholderRequest/NewPartnerRequest';
        const token = await getToken();
        const authHeader = ` ${token}`;
        return axios.post(url, data, {
            headers: {
                accept: 'application/json',
                Authorization: authHeader,
            },
        });
    }
}

async function getToken(): Promise<string> {
    return AuthenticationService.getToken();
}
